import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useParams } from 'react-router-dom';
import { fetchApi } from '../../helper/api';
import $, { each } from "jquery"
import moment from 'moment';
import { IsAlert } from '../atoms/IsAlert';
import { pesanCallback } from '../../helper/function';

const DownloadReport = () => {
    var params = useParams()

    useEffect(() => {
        getSensor()
    }, [])
    const [selectionRange, setSelectRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    })
    const [listSensor, setListSensor] = useState()

    const getSensor = async () => {
        var req = await fetchApi("api/Rtu/ipc/" + params.id, "GET", true)
        var res = await req.json()
        var status = req.status
        if (status == 200) {
            setListSensor(res.data)
        }
    }

    const handleDownload = async () => {
        var mulai = new Date(selectionRange.startDate)
        mulai.setHours(0, 0, 0)
        var selesai = new Date(selectionRange.endDate)
        selesai.setHours(23, 59, 59)
        console.log(mulai);
        console.log(selesai);
        var sensor = []
        var $boxes = $('.pilihan:checked');
        if ($boxes.length == 0) {
            IsAlert.fire({
                title: "",
                text: "Silahkan pilih sensor",
                icon: "error",
                showCancelButton: false,
                focusConfirm: true,
                confirmButtonText: 'OK',
                showCancelButton: false

            }).then(function (isConfirm) {
                if (isConfirm.isConfirmed) {
                    
                }
            })
        }
        else{
            $boxes.each(function (e) {
                sensor.push($(this).attr("data-id"))
            });
            var dataPost = {
                "fromTs": mulai.getTime(),
                "toTs": selesai.getTime(),
                "idSensors": sensor
            }
            var req = await fetchApi("api/Record/requestData", "POST", true, dataPost)
            var res = await req.json()
            var status = req.status
            pesanCallback(status, res)
        }
    }
    if (listSensor) {
        return (
            <div className='p-4'>

                <div className='row'>
                    <div className='col-lg-6'>
                        <DateRangePicker
                            ranges={[selectionRange]}
                            onChange={(e) => {
                                setSelectRange({
                                    startDate: new Date(e.selection.startDate),
                                    endDate: new Date(e.selection.endDate),
                                    key: 'selection',
                                })
                            }}
                        />
                    </div>
                    <div className='col-lg-6'>
                        <div className='bg-white' style={{ height: "343.96px" }}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th width="10px"></th>
                                        <th>Sensor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        Object.entries(listSensor).map((e) => {
                                            if (e[0] != 'Power Distribution') {
                                                return (
                                                    e[1].map((d, i) => {
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <input type="checkbox" data-id={d.idSensor} className="pilihan" id={`check${i}`} value="" />
                                                                </td>
                                                                <td>
                                                                    <label className="mb-0" htmlFor={`check${i}`}>{d.group} {d.numberSensor}</label>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                )
                                            }
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='col-lg-6 mt-4'>
                        <button className='btn btn-success d-flex align-items-center' onClick={() => handleDownload()}>
                            <i className="las la-save mr-2" style={{ fontSize: 24 }}></i>
                            Download Report
                        </button>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return <p className='p-4 text-center'>Loading...</p>
    }
}
export default DownloadReport